import axiosConfig from '@lib/axiosConfig';


export const OmbudsmanFollowupService = {

    list: async function () {
        return await axiosConfig.get('/ombudsman-followups');
    },

    show: async function (id) {
        return await axiosConfig.get(`/ombudsman-followups/show/${id}`);
    },

    fetchbyfilter: async function (filter, order) {
        return await axiosConfig.get(`/ombudsman-followups/fetchbyfilter/${filter}/${order}`);
    },

    store: async function (data) {
        return await axiosConfig.post('/ombudsman-followups/store', data);
    },

    update: async function (data, id) {
        return await axiosConfig.put(`/ombudsman-followups/update/${id}`, data);
    },

    delete: async function (id) {
        return await axiosConfig.delete(`/ombudsman-followups/delete/${id}`);
    },

};